import { render } from "./ScreenPortraitStatusStream.vue?vue&type=template&id=631d80ee&scoped=true"
import script from "./ScreenPortraitStatusStream.vue?vue&type=script&lang=js"
export * from "./ScreenPortraitStatusStream.vue?vue&type=script&lang=js"

import "./ScreenPortraitStatusStream.vue?vue&type=style&index=0&id=631d80ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631d80ee"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QChip});
